import React from "react";
import Header from "./Header";
import KatlasStatusBadge from "./KatlasStatusBadge";

export default function Layout({ children, hideHeader }) {
    return (
        <div className="App min-h-screen bg-parchment">
            {!hideHeader && <Header />}
            <main className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 lg:py-14">
                {children}
            </main>
            <footer className="border-t border-parchment-rule mt-16">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-3">
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-muted">
                        Custody · Authority · Receipts
                    </p>
                    <KatlasStatusBadge />
                    <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-muted">
                        AI may recommend. The underwriter decides. KATLAS signs the receipt.
                    </p>
                </div>
            </footer>
        </div>
    );
}
